module.exports = __webpack_public_path__ + "img/15.20a64528.png";